import React from 'react';
import { Menu } from 'antd';


const menuItems = () => {
  return [
    <Menu.Item key="home">
      CV
    </Menu.Item>,
    <Menu.Item key="blog">
      <a href="https://wasteland.touko.moe/">Blog</a>
    </Menu.Item>,
    <Menu.Item key="github">
      <a href="https://github.com/HoshinoTouko/">GitHub</a>
    </Menu.Item>
  ];
};


class AppHeaderMenu extends React.Component {
  render() {
    return (
      <Menu className="app-header-menu" mode="horizontal" defaultSelectedKeys={['home']}>
        {menuItems()}
      </Menu>
    );
  }
}

export default AppHeaderMenu;